import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';

const GRID_COLUMN_COUNT = 12;
const MAXIMUM_CARDS_PER_ROW = 4;

export class Steve extends Lit3formBlock {
  static get characterName() {
    return 'steve';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid steve-layout">
          ${this.headerHTML} ${this.cardsHTML} ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get headerHTML() {
    return this.headerText
      ? html`
          <h2 class="steve-header">${unsafeHTML(this.headerText)}</h2>
        `
      : html``;
  }

  get cardsHTML() {
    if (!this.cards.length) return html``;

    return html`
      <div class="steve-cards" style="--steve-card-span: ${this.cardSpan}">
        ${this.cards.map(card => this.cardHTML(card))}
      </div>
    `;
  }

  cardHTML(card) {
    return html`
      <div class="steve-card">
        <img src=${this.imageUrl(card)} />
        ${card.description
          ? html`
              <p class="steve-card-description">
                ${unsafeHTML(this.withLineBreaks(card.description))}
              </p>
            `
          : html``}
      </div>
    `;
  }

  // Cards divide the 12 page columns evenly, up to four per row. Past that
  // they stay a quarter wide and wrap onto the next row.
  get cardSpan() {
    return (
      GRID_COLUMN_COUNT / Math.min(this.cards.length, MAXIMUM_CARDS_PER_ROW)
    );
  }

  imageUrl(card) {
    // Width only — a height would crop. Cards keep their own aspect ratio.
    return this.imagebossUrl(card.src, 800);
  }

  get cards() {
    return this.content.cards || [];
  }
}
Steve.defineElement();
